import React from 'react';
import Image from '../../../01-atoms/images/ResponsiveImage/ResponsiveImage.component';
import { imageTypeProps } from '../../../01-atoms/images/Image/Image.component';
import bem from '../../../_utils/bem';
import Heading from '../../../01-atoms/text/Heading.component';
import Paragraph from '../../../01-atoms/text/Paragraph.component';
import Link from '../../../01-atoms/links/Link.component';

var Card = function Card(_ref) {
  var outputImage = _ref.outputImage,
      image = _ref.image,
      heading = _ref.heading,
      subheading = _ref.subheading,
      children = _ref.children,
      linkText = _ref.linkText,
      linkUrl = _ref.linkUrl,
      _ref$block = _ref.block,
      block = _ref$block === void 0 ? 'card' : _ref$block,
      element = _ref.element,
      modifiers = _ref.modifiers,
      additionalClasses = _ref.additionalClasses;
  return /*#__PURE__*/React.createElement("div", {
    className: bem(block, element, modifiers, additionalClasses)
  }, image && /*#__PURE__*/React.createElement("div", {
    className: bem(block, 'image')
  }, /*#__PURE__*/React.createElement(Image, {
    outputImage: outputImage,
    image: image
  })), /*#__PURE__*/React.createElement("div", {
    className: bem(block, 'content')
  }, heading && /*#__PURE__*/React.createElement(Heading, {
    level: "2",
    block: block,
    element: "heading"
  }, heading), subheading && /*#__PURE__*/React.createElement(Heading, {
    level: "3",
    block: block,
    element: "subheading"
  }, subheading), children && /*#__PURE__*/React.createElement(Paragraph, {
    block: block,
    element: "body"
  }, children), linkUrl && /*#__PURE__*/React.createElement(Link, {
    url: linkUrl,
    block: block,
    element: "link"
  }, linkText)));
};

export default Card;